var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLightIndustrialSegment(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.9098 5.625L19.2188 13.2246V5.625H17.1958L9.84375 13.0821V0.9375H0.9375V29.0625H29.0625V5.625H26.9098ZM27.1875 27.1875H2.8125V2.8125H7.96875V15.4688H10.1237L17.3438 8.14559V15.4688H19.6151L27.1875 7.98633V27.1875Z",
    fill: "#D2232A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.96875 19.2188V19.6875H9.84375V17.8125H7.96875V19.2188Z",
    fill: "#D2232A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.96875 22.0312H9.84375V23.9062H7.96875V22.0312Z",
    fill: "#D2232A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6562 19.2188V19.6875H14.5312V17.8125H12.6562V19.2188Z",
    fill: "#D2232A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6562 22.0312H14.5312V23.9062H12.6562V22.0312Z",
    fill: "#D2232A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3438 19.2188V19.6875H19.2188V17.8125H17.3438V19.2188Z",
    fill: "#D2232A"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3438 22.0312H19.2188V23.9062H17.3438V22.0312Z",
    fill: "#D2232A"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0312 17.8125H23.9062V19.6875H22.0312V17.8125Z",
    fill: "#D2232A"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0312 22.0312H23.9062V23.9062H22.0312V22.0312Z",
    fill: "#D2232A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightIndustrialSegment);
export default __webpack_public_path__ + "static/media/light-industrial-segment.60d5c2dd6386cb4dbd7044ab12df4110.svg";
export { ForwardRef as ReactComponent };